import { clearDrawerData, editUserId, originalUserData, showSaveConfirm, tableData, userErrorRegistry, userPayload } from "Pages/Admin/Users/@signals"
import { useCallback } from "react"
import { useSignal } from "@preact/signals-react"
import { postSubmit } from "@ui-seeker/utils"
import { BACKEND_APIS } from "@constants"
import { useToast } from "@hooks"

export default function useCreateUsersModal() {
	const isEditLoading = useSignal(false)
	const { showToast } = useToast()

	const setTableData = useCallback((res) => {
		const allUsers = [...tableData.value]

		const targetIdx = allUsers.findIndex(item => item?.uid === res?.uid)

		let updatedUsers
		if (targetIdx !== -1) {
			allUsers[targetIdx] = { ...res }
			updatedUsers = [...allUsers]
		} else {
			updatedUsers = [{ ...res }, ...allUsers]
		}
		tableData.value = updatedUsers
	}, [])


	const onSubmitModal = useCallback(() => {
		const { sites, offices, user, userConfig } = userPayload.value
		if (!sites?.length || !offices?.length || !user?.email || !user?.name || !user?.company || !userConfig?.userTZ || !user?.defaultCurrency) {
			showToast.error("All required fields must be filled (sites, offices, email, name, company, timezone and currency)")
			return
		}
		showSaveConfirm.value = false
		isEditLoading.value = true
		postSubmit(`${BACKEND_APIS.USER}/user-editor`, userPayload.value)
			.then(res => {
				setTableData(res)
				isEditLoading.value = false
				showToast.success("Succesfully submitted form!")
				clearDrawerData()
			})
			.catch(() => {
				showToast.error()
				isEditLoading.value = false
				clearDrawerData()
			})

	}, [])

	const onRequestSave = useCallback(() => {
		const { sites, offices, user, userConfig } = userPayload.value
		if (!sites?.length || !offices?.length || !user?.email || !user?.name || !user?.company || !userConfig?.userTZ || !user?.defaultCurrency) {
			showToast.error("All required fields must be filled (sites, offices, email, name, company, timezone and currency)")
			return
		}
		if (editUserId.value) {
			showSaveConfirm.value = true
		} else {
			onSubmitModal()
		}
	}, [])

	const onOpenModal = (clone = false) => {
		userErrorRegistry.value = { sites: false, offices: false }
		userPayload.value = {
			masterUsers: [],
			offices: [],
			sites: [],
			user: {
				company: "",
				defaultCurrency: "",
				email: "",
				expirationDate: "",
				extraFeatures: [],
				isMaster: false,
				name: "",
				password: "",
				passwordEnc: "",
				uid: null
			},
			userConfig: {
				onlyExport: false,
				userTZ: ""
			},
			clone: clone
		}
	}

	const onEditUser = useCallback(() => {
		isEditLoading.value = true
		userErrorRegistry.value = { sites: false, offices: false }
		postSubmit(`${BACKEND_APIS.USER}/user-data`, { uid: editUserId.value })
			.then(res => {
				originalUserData.value = JSON.parse(JSON.stringify(res))
				userPayload.value = {
					...res, clone: userPayload.value?.clone, ...userPayload.value?.clone && {
						user: {
							...res.user,
							uid: null,
							password: "",
							name: ""
						}
					}
				}
				isEditLoading.value = false
			})
			.catch(() => {
				showToast.error()
				isEditLoading.value = false
			})
	}, [])

	return {
		onOpenModal,
		onEditUser,
		onSubmitModal,
		onRequestSave,
		isEditLoading: isEditLoading.value
	}
}